/**
 * @desc 列表
 */
const URL = "/rantion-esca";
import http, { updateResponse } from "@/http";
export function request(body: defs.esca.EApiRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/eApi/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
